import { render, staticRenderFns } from "./SettingsAddNewStorageType.vue?vue&type=template&id=7c43b6d2"
import script from "./SettingsAddNewStorageType.vue?vue&type=script&lang=js"
export * from "./SettingsAddNewStorageType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports